import React, { useContext, useEffect, ReactNode } from "react";
import { TableContext, TableProvider } from "common/components/Table/TableProvider";

export interface ITableProps {
  block?: boolean;
  gridColsClass: string;
  id?: string;
  children: ReactNode;
  hover?: boolean;
}

export interface ITableColSpanProps {
  colSpanClasses?: string;
  /** Cross-axis alignment of the cell content; defaults to `"center"`. */
  align?: "center" | "start";
}

export const Table: React.FC<ITableProps> = (props) => {
  return (
    <TableProvider>
      <InnerTable {...props}></InnerTable>
    </TableProvider>
  );
};

const InnerTable: React.FC<ITableProps> = ({ block = false, gridColsClass, children, id, hover = true }) => {
  const { setGridColsClass, setHover } = useContext(TableContext);
  // Lifecycle
  useEffect(() => {
    setGridColsClass(gridColsClass);
  }, [gridColsClass]);

  // Lifecycle
  useEffect(() => {
    setHover(hover);
  }, [hover]);

  return (
    <div {...(id ? { id } : {})} role="table" className={`${block ? "w-full" : ""}`}>
      {children}
    </div>
  );
};
